import { Outlet } from "react-router-dom";

import { Header } from "@/features/shared/components";
import { AdminErrorBoundary } from "@/features/admin/components";

/**
 * Top-level admin shell with Header and an outer error boundary around route
 * content (including AdminDashboardLayout or standalone pages).
 */
const AdminHeaderLayout = () => (
  <>
    <Header />
    <AdminErrorBoundary tags={{ component: "AdminHeaderLayout" }}>
      <Outlet />
    </AdminErrorBoundary>
  </>
);

export default AdminHeaderLayout;
